<template>
  <div class="l-out-card">

      <div class="img">
          <l-img :src='src'></l-img>
      </div>

      <div class="info">

        <div class="info-container">

            <l-info-title :title='title' class="title"></l-info-title>
            <p  class="content">
                {{ content }}
            </p>
        </div>

        
      </div>
      
  </div>
</template>

<script>
export default {
    name: 'l-out-card',
    props:{
        src: {
            default:''
        },
        title: {
            default: ''
        },
        content: {
            default: ''
        }
    }

}
</script>
<style lang="scss" scoped>
.l-out-card{
    $h: 400px;
    $imgW: 400px;
    $contentH: 300px;
    height: $h;
    
    .title{
        margin-bottom: 24px;
    }
    .img{
        float: left;
        width: $imgW;
        height: 100%;
    }

    .info{
        position: relative;
        margin-left: $imgW;       
        box-sizing: border-box;
        height: 100%;

        
        .info-container {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            
            margin: auto;
            box-sizing: border-box;
            padding:  60px 82px 60px 76px;
            border: 1px solid $color_border;
            border-left: 0;
            height: $contentH;
        }

        .content{
            @include font_content;
        }
    }
}

</style>